import type { IState } from '@/frontend/src/types/context';
import { EActiveView, EContext } from '@/frontend/src/types/context';
import { EPortal } from '@/frontend/src/types/portal';
import type { EPlaceTypes } from '@/frontend/src/types/geo';

export const initialState: IState = {
    context: EContext.EstimationFunnel,
    geo: {
        countries: [],
        placeTypes: [],
    },
    portal: EPortal.Immonet,
    ctaButtonInfo: {
        url: '',
    },
    formValues: {},
    locationResult: {
        id: '',
        typeKey: undefined as EPlaceTypes | undefined,
        postalCode: '',
        city: '',
        street: '',
        houseNumber: '',
    },
    closestLocationResult: {
        id: '',
        typeKey: undefined as EPlaceTypes | undefined,
        postalCode: '',
        city: '',
        street: '',
        houseNumber: '',
        displayName: '',
    },
    activeView: EActiveView.LocationSearch,
    shouldDisplayHouseNumber: false,
    isInvalidAddress: false,
};
